import { createRoute } from 'utils/routes'
import DashBoard from './DashBoard'

export default {
    dashboard: createRoute({
        title: 'Dashboard',
        path: '/dashboard',
        component: DashBoard,
        exact: true,
        context: 'super-home'
    }),
}
